import { SetError } from '../../redux/modals';
import { DagLambdaFetch } from '../../utils/fetch-utils';

interface StartDagArgs {
  dag: string;
  ingestionType: string;
  setError: SetError;
}

export const startDag = async ({ dag, ingestionType, setError }: StartDagArgs): Promise<void> => {
  try {
    const body: { dag: string; include_last_run_info: boolean; ingestion_type?: string } = {
      dag,
      include_last_run_info: false
    };

    if (ingestionType === 'streaming' || ingestionType === 'linear') {
      body.ingestion_type = ingestionType;
    }
    await DagLambdaFetch('/start', {
      method: 'POST',
      body,
      retries: 0
    });
  } catch (e) {
    setError({
      message: `Failed to start dag ${dag} with ingestion type ${ingestionType}`,
      reportError: e
    });
  }
};
